import { useSelector } from 'react-redux';
import { RootState } from '../store/reducers';
import _get from 'lodash/get';
import { MessageValue } from 'react-intl';
import { tooltipNotifications } from '../constants/Notification';

export enum NotificationType {
  PILL,
  TOOLTIPS,
  TOOLTIP_IN_CALL_ACTION_RAISE_HAND,
  TOOLTIP_IN_CALL_DRAWER_RAISE_HAND
}

export interface AppNotification {
  messageType: string;
  id?: string;
  defaultMessage?: string;
  values?: { [key: string]: MessageValue | JSX.Element };
}

export default function useAppNotification(type: NotificationType): AppNotification | undefined {
  const notificationState = useSelector((state: RootState) => state?.app?.notification);
  if (!!notificationState) {
    switch (type) {
      case NotificationType.PILL:
        return notificationState?.pill;
      case NotificationType.TOOLTIPS:
        return notificationState?.tooltips;
      case NotificationType.TOOLTIP_IN_CALL_ACTION_RAISE_HAND:
        return _get(notificationState, `tooltips.${tooltipNotifications.inCallActionBtnRaiseHand}`) || undefined;
      case NotificationType.TOOLTIP_IN_CALL_DRAWER_RAISE_HAND:
        return _get(notificationState, `tooltips.${tooltipNotifications.inCallDrawerBtnRaiseHand}`) || undefined;
    }
  }

  return undefined;
}
